import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TrustStrip from "@/components/TrustStrip";
import Philosophy from "@/components/Philosophy";
import CareJourney from "@/components/CareJourney";
import Treatments from "@/components/Treatments";
import Nourishment from "@/components/Nourishment";
import VillaGallery from "@/components/VillaGallery";
import Pricing from "@/components/Pricing";
import BookingForm from "@/components/BookingForm";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import MobileReserveBar from "@/components/MobileReserveBar";
import LocationPage from "@/pages/LocationPage";
import FaqPage from "@/pages/FaqPage";
import BlogPostPage from "@/pages/BlogPostPage";

const Landing = () => {
  return (
    <main className="min-h-screen bg-ivory text-charcoal" data-testid="landing-page">
      <Navbar />
      <Hero />
      <TrustStrip />
      <Philosophy />
      <CareJourney />
      <Treatments />
      <VillaGallery />
      <Pricing />
      <Nourishment />
      <BookingForm />
      <Testimonials />
      <FAQ />
      <Footer />
      <WhatsAppFAB />
      <MobileReserveBar />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route
            path="/postnatal-care-palakkad-thrissur"
            element={<LocationPage />}
          />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/blog/what-is-prasava-raksha" element={<BlogPostPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
